import React from 'react';

import Accordion from '../../../components/Accordion';
import CableIcon from '@mui/icons-material/Cable';
import BtnFilled from '../../../components/BtnFilled';
import { FormProvider, useForm } from 'react-hook-form';
import ControlledInput from '../../../components/ControlledInput';
import { recalculateDataDevice } from '../../../api/api';
import { toast } from 'react-toastify';
import LabelWithTooltip from '../../../components/LabelWithTooltip';

const STEPS = [
  'Зажмите скрытую кнопку на контроллере на 2 сек. до зелёного светодиода.',
  'Подождите ~ минуту, пока контроллер передаст накопленные данные.',
  'Введите нужные показания.',
];

const Tooltips = () => {
  return (
    <div className="w-full rounded-xl border px-3 py-2 mb-4">
      <p className="text-sm font-medium text-gray-900 mb-3">Перед редактированием показаний выполните шаги:</p>
      <div className="flex flex-col gap-2">
        {STEPS.map((text, i) => (
          <div key={i} className="flex gap-2">
            <div className="mt-[1px] flex h-5 w-5 items-center justify-center rounded-full bg-orange-500 text-xs font-bold text-white">{i + 1}</div>
            <span className="flex-1 text-sm text-gray-700">{text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const SettingDataForm = ({ deviceId }) => {
  const [accordion, setAccordion] = React.useState({ 1: true });
  const methods = useForm({ mode: 'onChange', defaultValues: { multiplier: 1 } });

  const handleSubmit = async (data) => {
    const body = { current_value: Number(data?.current_value) };
    await recalculateDataDevice({
      deviceId,
      body,
      dataCb: () => toast.success('Ваши данные успешно обновлены!'),
      errCb: (err) => toast.error(`Произошла ошибка при обновлении данных ${err?.error ?? ''}`),
    });
  };

  return (
    <Accordion initialValue={{ two: true }} accordion={accordion} setAccordion={setAccordion} id={'two'} Icon={CableIcon} name={'Редактировать показания'}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <ControlledInput
            rules={{ required: 'Введите поправку показаний' }}
            name={'current_value'}
            label={
              <LabelWithTooltip text="Введите текущее показание в литрах" tooltipImage={'/images/meter.png'} tooltipText={`4,736 куб.метр = 4736 литров`} />
            }
            classContainer="w-full mt-4"
            type="number"
            placeholder={'0'}
            onCustomChange={(e) => {
              const value = e.target.value;
              return value.replace(/[^0-9]/g, '');
            }}
          />
          <Tooltips />
          <BtnFilled title={'Обновить показания'} className={'flex w-fit m-auto my-4 px-10'} type={'submit'} />
        </form>
      </FormProvider>
    </Accordion>
  );
};
export default SettingDataForm;
